import { MenuItem } from "../../../app/common-models/IMenus";
import menuItems from "../helperDataset/menuItems.json";


export function generateHeader(location: string) {
  const location_urls = location.split("/").filter(Boolean);
  let mappedBreadCrumbs: MenuItem[] = [];

  for (const menu of menuItems) {
    if (menu.dropdown.length > 0) {
      mappedBreadCrumbs.push(...menu.dropdown);
    }
    mappedBreadCrumbs.push(menu);
  }


  // Handle "update-password" route manually
  if (location_urls[0] === "update-password") {
    return [
      {
        name: "Update Password",
        url: "update-password",
        icon: "updatePassword",
        navigation: "/user/update-password",
        show: true
      }
    ];
  }

  if (location_urls.length > 1) {
    const [firstSegment, secondSegment, thirdSegment] = location_urls;
    
    // Handle specific routes for "customers", "jobs", "user", and "leads"
    switch (firstSegment) {
      case "customers":
        location = secondSegment === "edit" ? `${firstSegment}/${secondSegment}` : `${firstSegment}/:id`;
        break;
      case "jobs":
        location = secondSegment === "add-job" || secondSegment === "edit" ? `${firstSegment}/${secondSegment}` : `${firstSegment}/:id`;
        break;
      case "user":
        switch (secondSegment) {
          case "view-profile":
            location = `${firstSegment}/${secondSegment}/:id`;
            break;
          case "requests":
            if (location_urls.length > 2) {
            location = location_urls[2] === "view-profile" ? `${firstSegment}/${secondSegment}/${thirdSegment}/:id` : `${firstSegment}/${secondSegment}/${thirdSegment}/:id`;
            }else{
              location = `${firstSegment}/${secondSegment}`;
            }
            break;
          case "add-user":
            location = `${firstSegment}/${secondSegment}`;
            break;
          case "users":
            if (location_urls.length > 2) {
              location = location_urls[2] === "view-profile" ? `${firstSegment}/${secondSegment}/${thirdSegment}/:id` : `${firstSegment}/${secondSegment}/${thirdSegment}/:id`;
              }else{
                location = `${firstSegment}/${secondSegment}`;
              }
              break;
          default:
            break;
        }
        break;
      case "leads":
        if (location_urls.length === 2 && secondSegment === "all-leads") {          
          location_urls[0] = "leads";
          location_urls[1] = "all-leads";
        }

        if (location_urls.length === 3 && secondSegment === "all-leads") {
          location_urls[0] = "all-leads";
          location_urls[1] = ":id";
        }
        location = `${location_urls[0]}/${location_urls[1]}`;
        break;
      default:
        break;
    }
  }

  return mappedBreadCrumbs.filter((headline: MenuItem) => headline.navigation === location);
}
